<app-slide-in-right-modal modalTitle="Repush Transaction" iconImageSrc="assets/images/svgs/document--outline.svg"
    [slideOpen]="true">
    <div class="page__container flex flex-col pb-8">
        <p class="cta__text text-sm text-mango-gray74">
            Kindly enter session of a failed transaction to repush transaction
        </p>

        <form class="flex flex-col gap-5 px-0 pt-5" [formGroup]="repushForm">


            <app-input-label labelFor="start-date" labelClass="label--bottom-margin">Session ID</app-input-label>

            <app-input placeholder="Enter Transaction Session ID" inputClass="input--padding"
                formControlName="session_id"></app-input>


            <div class="col-start-3 justify-self-end" *appHasPermission="'repush_providus_transaction'">
                <button (click)="repushTransaction()" [disabled]="repushForm.invalid"
                    class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end" mango-button>
                    @if (isLoading$ | async) {
                    <span>Repushing transaction...</span>
                    } @else {
                    <span>Repush</span>
                    }
                </button>
            </div>
        </form>
    </div>
</app-slide-in-right-modal>